import { render, staticRenderFns } from "./InviteFriendsView.vue?vue&type=template&id=116d1b93&scoped=true"
import script from "./InviteFriendsView.vue?vue&type=script&lang=js"
export * from "./InviteFriendsView.vue?vue&type=script&lang=js"
import style0 from "./InviteFriendsView.vue?vue&type=style&index=0&id=116d1b93&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116d1b93",
  null
  
)

export default component.exports